import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"col-6\"><div class=\"input-group\"><div class=\"input-group-prepend\"><label class=\"input-group-text\" for=\"billing_cycle\">Billing Cycle</label></div><select class=\"form-control\" id=\"billing_cycle\"><option value=\"1\">Annual (25 discount)</option><option value=\"2\">Monthly</option></select></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}